import styled from 'styled-components'

const BackdropEl = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 998;
`

const Backdrop = ({ onClick }) => {
  return <BackdropEl onClick={onClick} />
}

export default Backdrop
